import { useTranslation } from "react-i18next"
import { format } from "date-fns"

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardFooter,
  CardTitle,
} from "@f2e/ui/components/base"

import { Workspace, Agent } from "@/types"
import type { KnowledgeBaseFolder } from "@/hooks/api"
import { AgentInlineActions } from "./AgentInlineActions"
import { AgentSourceBadgeGroup } from "./AgentSourceBadgeGroup"

export interface CustomizeAgentCardProps {
  workspace: Workspace
  agent: Agent
  knowledgeBaseMap: Map<string, KnowledgeBaseFolder>
  onPlayground?: (agent: Agent) => void
  onDelete?: (agent: Agent) => void
}

const CustomizeAgentCard = ({
  workspace,
  agent,
  knowledgeBaseMap,
  onPlayground,
  onDelete,
}: CustomizeAgentCardProps) => {
  const { t } = useTranslation()
  return (
    <Card className="hover:bg-slate-50 dark:hover:bg-slate-900">
      <div className="flex w-full items-start gap-2">
        <CardHeader className="min-w-0 flex-1 my-4 py-0 pr-0">
          <CardTitle className="text-xl flex items-center">
            <Button
              variant="link"
              className="text-xl h-auto p-0 ml-2 text-wrap break-all text-left"
              onClick={() => onPlayground?.(agent)}
            >
              {agent.name}
            </Button>
          </CardTitle>
        </CardHeader>
        <AgentInlineActions
          className="mt-3 mr-3 shrink-0"
          agent={agent}
          workspace={workspace}
          onPlayground={onPlayground}
          onDelete={onDelete}
        />
      </div>
      <CardContent>
        <AgentSourceBadgeGroup
          agent={agent}
          knowledgeBaseMap={knowledgeBaseMap}
        />
        <div className="mt-2 text-slate-500">
          {agent.description || t("workspace.agent.noDescription")}
        </div>
      </CardContent>
      <CardFooter className="flex flex-col space-y-1 text-xs text-slate-500">
        <div className="flex justify-between items-start w-full">
          <div>{t("workspace.createdAt")}</div>
          <div>{format(agent.createdAt, "yyyy-MM-dd HH:mm:ss")}</div>
        </div>
        <div className="flex justify-between items-end w-full">
          <div>{t("workspace.updatedAt")}</div>
          <div>{format(agent.updatedAt, "yyyy-MM-dd HH:mm:ss")}</div>
        </div>
      </CardFooter>
    </Card>
  )
}

export { CustomizeAgentCard }
export default CustomizeAgentCard
